/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Page.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-page");
exports.Page = function Page(_a) {
    var className = _a.className, children = _a.children, grey = _a.grey, lightBlue = _a.lightBlue, lightMetroBlue = _a.lightMetroBlue;
    var cssClasses = ["m-page", className];
    if (grey) {
        cssClasses.push("m-page-greyBackground");
    }
    else if (lightBlue) {
        cssClasses.push("m-page-lightBlueBackground");
    }
    else if (lightMetroBlue) {
        cssClasses.push("m-page-lightMetroBlueBackground");
    }
    return React.createElement("div", { className: classnames(cssClasses) }, children);
};
exports.Page.propTypes = {
    className: PropTypes.string,
    lightBlue: PropTypes.bool,
    lightMetroBlue: PropTypes.bool,
    grey: PropTypes.bool
};
exports.PageContent = function PageContent(_a) {
    var centered = _a.centered, children = _a.children, noPadding = _a.noPadding, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName("container"), className, centered && moduleClassName("container-isCentered"), noPadding && moduleClassName("container-noPadding")) }, children));
};
exports.PageContent.propTypes = {
    className: PropTypes.string,
    centered: PropTypes.bool,
    noPadding: PropTypes.bool
};
exports.PageLayout = function PageLayoutContent(_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName("layout"), className) }, props), children));
};
exports.PageLayoutSidebar = function PageLayoutSidebar(_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement("aside", tslib_1.__assign({ className: classnames(moduleClassName("layoutSidebar"), className) }, props), children));
};
exports.PageLayoutContent = function PageLayoutContent(_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName("layoutContent"), className) }, props), children));
};